import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SubscriptionItemProps } from '../../../../store/subscription/types';
import { SubscriptionDetailProvider } from '../../contexts/SubscriptionDetail';
import { SubscriptionItemDetails } from '../SubscriptionItemDetails';

import { SubscriptionSmallCardDesktop } from './Desktop';
import { SubscriptionSmallCardMobile } from './Mobile';
import { SubscriptionSmallCardTablet } from './Tablet';

export interface SubscriptionSmallCardProps {
  subscription: SubscriptionItemProps;
}

export const SubscriptionSmallCard: React.FC<SubscriptionSmallCardProps> = (props) => {
  const responsiveItem = useBreakpointValue({
    base: <SubscriptionSmallCardMobile {...props} />,
    sm: <SubscriptionSmallCardTablet {...props} />,
    lg: <SubscriptionSmallCardDesktop {...props} />,
  });

  return (
    <SubscriptionDetailProvider>
      <SubscriptionItemDetails />
      {responsiveItem}
    </SubscriptionDetailProvider>
  );
};
